(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@angular/core"), require("@angular/common"), require("@angular/forms"), require("@angular/animations"));
	else if(typeof define === 'function' && define.amd)
		define(["@angular/core", "@angular/common", "@angular/forms", "@angular/animations"], factory);
	else if(typeof exports === 'object')
		exports["angularx-semantic-ui.umd"] = factory(require("@angular/core"), require("@angular/common"), require("@angular/forms"), require("@angular/animations"));
	else
		root["angularx-semantic-ui.umd"] = factory(root["@angular/core"], root["@angular/common"], root["@angular/forms"], root["@angular/animations"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_7__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition